export default {
  loading: '正在努力加载...',
  language: '语言',
  languageZh: '中文',
  languageEn: 'English',
  noData: '暂无数据',
  confirm: '确认',
  cancel: '取消',
}
